/** Which of the viewer's threads the Threads section lists. */
export enum ThreadsFilter {
  /** Not muted and not archived: the recent window plus anything unread. */
  Active = 'active',
  Unread = 'unread',
  Muted = 'muted',
  Archived = 'archived',
}
